export default "__VITE_ASSET__CmtJ3Sqi__"